import React from 'react';
import './Results.css';
import './YogaClass.css';

const btnClass =
  'tc tracked bg-black white bw0 br4 pt2 pb2 center db ttu no-underline';

const YogaClass = ({ c }) => {
  const categories = c.categories
    .filter((cat) => cat !== 'cp Anything')
    .map((cat) => cat.replace('cp', '').trim());
  return (
    <tr className="stripe-dark" key={c.id}>
      <td className="pa3">{c.title}</td>
      <td className="pa3">{Math.ceil(c.duration / 60)}</td>
      <td className="pa3">{categories.join(', ')}</td>
      <td className="pa3">
        <a
          className={`${btnClass} button`}
          href={c.url}
          target="_blank"
          rel="noreferrer"
        >
          Take Class
        </a>
      </td>
    </tr>
  );
};

export default YogaClass;
